<template>
  <PagePreloader />
  <teleport to="body">
    <GlobalToast />
    <PleaseWaitPreloader v-if="isRequesting" :title="waitPreloaderTitle || undefined" />
  </teleport>
  <StayWithUs v-if="flow !== 'mainsite'" />
  <HeaderBlock v-if="flow !== 'mainsite'" />
  <ReloadPrompt />
  <main>
    <router-view :key="$route.path" />
  </main>
  <ProjectVersion v-if="flow !== 'mainsite'" />
  <!-- <WhatsAppWidget /> -->
</template>
<script setup>
import { onBeforeMount, onMounted, defineAsyncComponent } from 'vue'
import { storeToRefs } from 'pinia'

import { useCentrifugoStore, useMainStore, useRidesHistoryStore } from '@/stores'
import { useUserStore } from '@/stores'

import PagePreloader from '@/components/ui/loaders/PagePreloader.vue'
import PleaseWaitPreloader from '@/components/ui/loaders/PleaseWaitPreloader.vue'
import GlobalToast from '@/components/ui/GlobalToast.vue'
import { chunkErrorDetected, isChunkLoadError } from '@/utils/chunkError'

// Top-level async components aren't covered by router.onError or main.js's window
// listeners (their load failures go straight to Vue's app.config.errorHandler, i.e.
// straight to Sentry) — route the same stale-chunk case through chunkErrorDetected here too.
function asyncComponent(loader) {
  return defineAsyncComponent({
    loader,
    onError(error, retry, fail) {
      if (isChunkLoadError(error)) {
        chunkErrorDetected.value = true
        return
      }
      fail(error)
    }
  })
}

const HeaderBlock = asyncComponent(() => import('@/blocks/HeaderBlock.vue'))
const ProjectVersion = asyncComponent(() => import('@/components/ui/utils/ProjectVersion.vue'))
const ReloadPrompt = asyncComponent(() => import('@/components/ui/utils/ReloadPromptPWA.vue'))
const StayWithUs = asyncComponent(() => import('@/components/layout/marketing/StayWithUs.vue'))
// const WhatsAppWidget = defineAsyncComponent(() => import('@/components/layout/WhatsAppWidget.vue'))

const centrifugoStore = useCentrifugoStore()
const mainStore = useMainStore()
const ridesHistoryStore = useRidesHistoryStore()
const userStore = useUserStore()
const { flow, ssid, isRequesting, waitPreloaderTitle } = storeToRefs(mainStore)
const { isLoggedIn } = storeToRefs(userStore)
const { isRequestSuccessful, isRequestPending, isRequestRefused } = storeToRefs(ridesHistoryStore)

onBeforeMount(async () => {
  let channels = []

  if (isLoggedIn.value) {
    const userId = userStore.user.id
    channels.push({
      event: 'as.orders.request.status',
      name: `Orders.History.Request.Status.Change.${userId}`,
      action: (data) => {
        if (data.status === 'succeed') {
          ridesHistoryStore.updateRequestStatus('succeed')
          isRequestSuccessful.value = true
        } else {
          ridesHistoryStore.updateRequestStatus('refused')
          isRequestRefused.value = true
        }
        isRequestPending.value = false
      }
    })
    channels.push({
      event: 'as.orders',
      name: `Orders.History.Ready.${userId}`,
      action: (data) => {
        ridesHistoryStore.updateRides({ data: data.orders })
        if (data.orders.length === 0) {
          ridesHistoryStore.updateRequestStatus('empty')
          isRequestRefused.value = false
          isRequestSuccessful.value = false
          isRequestPending.value = false
        }
      }
    })
  }

  if (flow.value === 'mainsite') {
    channels.push({
      event: 'fill_form',
      name: `dli-` + ssid.value,
      action: () => {}
    })
  }

  if (channels.length > 0) {
    centrifugoStore.connect(channels)
  }
})

onMounted(() => {})
</script>
